import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { create as createRequest, getAll } from './requests';
import { PromptTestCaseRequest, QueryKey } from 'api/model';
import { toast } from 'react-toastify';
import { errorHandler } from 'api/axios_instance';

const queryKey = QueryKey.PromptTestCases;

const usePromptTestCases = (promptId: string) => {
  const queryClient = useQueryClient();

  const { data: list, isLoading } = useQuery({
    queryKey: [queryKey, { promptId }],
    queryFn: () => getAll(promptId),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  const create = useMutation({
    mutationFn: (data: PromptTestCaseRequest) => createRequest(promptId, data),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [queryKey] });
      void queryClient.invalidateQueries({ queryKey: [QueryKey.PromptModels] });
      toast.success('Prompt test case successfully created');
    },
    onError: errorHandler('Creating prompt test case failed'),
  });

  return { list, isLoading, create };
};
export { queryKey };
export default usePromptTestCases;
